<script>
    import V from 'voUtils/V.js'

    export default {
    	voVueComponent: 'contact-sidebar',
    	voVueComponent: 'close-contact',
    	props: {
    		imageClass: String,
    		closeClass: String
    	},

    	mounted: function() {
    		$('.' + this.imageClass).click(function() {
    			$('.contact-sidebar').addClass("show");

    			$(".search-sidebar").addClass("search-close");
    			$(".search-open-icon").show();
    			$(".contact-sidebar").addClass("close-search-block");
    			$(".oro-sidebar").addClass("close-oro-search-block");
    			$('.oro-sidebar').removeClass("show");
    			$('.oro-sidebar').addClass("close-oro-search-block-2");

    		});
    		$('.' + this.closeClass).click(function() {
    			$('.contact-sidebar').removeClass("show");
    			$('.oro-sidebar').removeClass("close-oro-search-block-2");
    		});
    	}
    };
</script>